export const getProductLineByPolicyType = (productType) => {
  if (productType?.toUpperCase()?.slice(0, 1) === "A") {
    return "Annuity";
  } else return "Life";
};
